<template>
  <!-- The square an icon (or a step number, or an emoji) sits in, beside a
       heading. `brand` is the indigo tile of the marketing pages; `neutral` is
       for app and status screens, where indigo would read as a call to action.
       The content sizes itself (an icon is h-5 w-5 in `md`). -->
  <span
    class="flex shrink-0 items-center justify-center rounded-lg border"
    :class="[TONES[tone], SIZES[size]]"
    aria-hidden="true"
  >
    <slot />
  </span>
</template>

<script setup>
defineProps({
  tone: { type: String, default: 'brand' },
  size: { type: String, default: 'md' },
})

const TONES = {
  brand: 'border-indigo-500/30 bg-indigo-500/20 text-indigo-400',
  neutral: 'border-gray-700 bg-gray-800 text-gray-200',
}

const SIZES = {
  sm: 'size-8 text-sm font-bold',
  md: 'size-9 text-sm font-bold',
  lg: 'size-12 text-base',
}
</script>
